import { LAYERS, PLACEMENTS } from 'bloko/blocks/drop/constants';

export const ANIMATION_TIMEOUT_MS = 32;
export const ARROW_SIZE = 5;
export const BASE_CLASS_NAMES = ['bloko-drop', 'bloko-drop_tip'];
export const PLACEMENT_TIP_SEQUENCE = [PLACEMENTS.top, PLACEMENTS.right, PLACEMENTS.bottom, PLACEMENTS.left];
export const TIP_PLACEMENTS = Object.entries(PLACEMENTS).reduce((acc, [key, value]) => {
    if (!PLACEMENT_TIP_SEQUENCE.includes(value)) {
        return acc;
    }
    acc[key] = value;
    return acc;
}, {});

export const THEMES = {
    dark: 'dark',
    attention: 'attention',
};

export default {
    theme: THEMES.dark,
    layer: LAYERS.aboveContent,
    placement: TIP_PLACEMENTS.top,
    dataQa: 'bloko-drop-tip',
    show: false,
    host: null,
};
